import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { WebSpeechComponent } from './web-speech.component';
import { FormsModule } from '@angular/forms';
import { SpeechRecognizerService } from './services/speech-recognizer.service';
import { WebSpeechComponent } from './web-speech.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  providers: [SpeechRecognizerService],
  declarations: [WebSpeechComponent],
  exports: [WebSpeechComponent]
})
export class WebSpeechModule { }
